"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Promotion = void 0;
var moment_1 = __importDefault(require("moment"));
var Promotion = /** @class */ (function () {
    function Promotion(data) {
        var _this = this;
        this.isActive = function () {
            var nowToday = moment_1.default();
            return !(!_this.entryStart || nowToday < moment_1.default(_this.entryStart) || (!!_this.entryEnd && nowToday > moment_1.default(_this.entryEnd)));
        };
        this.isComingSoon = function () {
            var nowToday = moment_1.default();
            return !!_this.entryStart && moment_1.default(_this.entryStart).isAfter(nowToday);
        };
        this.isEndingSoon = function () {
            var nowToday = moment_1.default();
            return !!_this.endingSoon && !!_this.entryEnd && moment_1.default(_this.endingSoon).isBefore(nowToday) && moment_1.default(_this.entryEnd).isAfter(nowToday);
        };
        this.isEnded = function () {
            var nowToday = moment_1.default();
            return !!_this.entryEnd && moment_1.default(_this.entryEnd).isBefore(nowToday);
        };
        this.getPromotionStatus = function () {
            var promotionStatus = '';
            if (_this.isEnded()) {
                promotionStatus = 'ENDED';
            }
            else if (_this.isEndingSoon()) {
                promotionStatus = 'ENDING_SOON';
            }
            else if (_this.isComingSoon()) {
                promotionStatus = 'COMING_SOON';
            }
            return promotionStatus;
        };
        this.isJackpotReached = function () {
            return !!_this.progressivePrize &&
                !!_this.progressivePrize.ceiling &&
                !!_this.progressivePrize.value
                && _this.progressivePrize.value >= _this.progressivePrize.ceiling;
        };
        this.id = data.id;
        this.name = data.name;
        this.posImage = data.posImage;
        this.fullImage = data.fullImage;
        this.description = data.description;
        this.promotionType = data.promotionType;
        this.additionalInformation = data.additionalInformation;
        this.rulesDocument = data.rulesDocument;
        this.start = data.start;
        this.end = data.end;
        this.order = data.order;
        this.entryStart = data.entryStart;
        this.entryEnd = data.entryEnd;
        this.endingSoon = data.endingSoon;
        this.progressivePrize = null;
        this.progressiveDrawDate = null;
        this.progressiveEntryEndDate = null;
        this.progressiveDrawNumber = null;
    }
    Promotion.JsonToEntities = function (data) { return data.map(Promotion.JsonToEntity); };
    Promotion.JsonToEntity = function (data) { return new Promotion(data); };
    return Promotion;
}());
exports.Promotion = Promotion;
//# sourceMappingURL=Promotion.js.map